module.exports = __webpack_public_path__ + "static/media/qa.b314986b.svg";